<div *ngIf="comments?.values.length > 0 ; else empty">
  <app-comment class="d-block mt-2" *ngFor="let comment of comments?.values | orderBy:'desc':'date'" [comment]="comment" [color]="color" (sendDelete)="receiveDelete($event)" (sendEdit)="receiveEdit($event)"></app-comment>
</div>

<ng-template #empty>
  <app-empty [action]="false"></app-empty>
</ng-template>

<app-comment-editor *ngIf="user.roles.has('c')" class="d-block w-100 mb-4" [color]="color" (sendComment)="receiveComment($event)"></app-comment-editor>